<template>
  <BasicSidebar ref='sidebar'>
    <Loading :visible='loading'>
      <el-form ref='form' :model='form' :rules='rules'>
        <el-form-item label='Email' prop='email'>
          <el-input v-model='form.email' />
        </el-form-item>
        <el-form-item>
          <BasicButton @click='onCopy'>Copy Permission</BasicButton>
        </el-form-item>
      </el-form>
    </Loading>
  </BasicSidebar>
</template>

<script>
import sidebar from '@core/mixins/sidebar'
import BasicSidebar from '@core/components/common/BasicSidebar'
import BasicButton from '@/components/BasicButton'
import form, { customizeValidator, emailValidator, requireValidator } from '@core/mixins/form'
import { copyUserPermissions } from '@/util/api'
import { notify } from '@core/utils/elementUtil'
import Loading from '@/components/Loading'

export default {
  name: 'PermissionBasicSidebar',
  components: { Loading, BasicButton, BasicSidebar },
  mixins: [sidebar, form],
  data() {
    return {
      permissions: [],
      rules: {
        email: [requireValidator(), emailValidator(), customizeValidator('Can not copy permissions to himself!', (rule, value, callback) => {
          const user = JSON.parse(localStorage.getItem('dbClickUser'))
          if (value === user.email) {
            callback(rule.message)
          } else {
            callback()
          }
        })]
      },
      loading: false
    }
  },
  methods: {
    setPermissions(val) {
      this.form = this.initForm()
      this.$refs.form.resetFields()
      this.permissions = val
    },
    async onCopy() {
      try {
        await this.$refs.form.validate()
        const data = {
          permissions: this.permissions,
          email: this.form.email
        }
        const { organisationId } = this.$route.params
        this.loading = true
        await copyUserPermissions(organisationId, data)
        notify('Success', 'success')
        this.close()
      } catch (e) {
        if (e) {
          console.error(e)
        }
      } finally {
        this.loading = false
      }
    },
    initForm() {
      return { email: null }
    }
  }
}
</script>

<style scoped>

</style>
